import { CareProviderRole } from "./CareProviderRole";

class BritishColumbiaObstetricalFileComments {
    public Comments: string;
    public CareProvider: string;
    public CareProviderRole: CareProviderRole;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileComments>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFileComments };
